// 商品上下架管理api
import {ServerDistApi, ServerProdApi , ServerProdApidl} from '@/group-cloud/network/ServerBizApi';
//上架模式:1是合并上架；2是分开上架
export const Shelf_Mode_Types = {
    MEARGE: 1,
    INDEPENDENT: 2
}
export const Shelf_Mode_Types_Opts = [
    {id: Shelf_Mode_Types.MEARGE, label: '合并上架'},
    {id: Shelf_Mode_Types.INDEPENDENT, label: '分开上架'}
];

//上架逻辑：1增量， 0减量
export const Logic_Mode_Types = {
    REDUCE:0,
    ADD: 1
}
export const Logic_Mode_Opts = [
    {id: Logic_Mode_Types.REDUCE, label: '减量'},
    {id: Logic_Mode_Types.ADD, label: '增量'}
];

//客户类型（上架类型）：
export const Customer_Types_Opts = [
    // {id: 1, label: '总部'},
    {id: 2, label: '大连锁商SKA',type:0},
    {id: 5, label: '大零售商SCA',type:0},
    {id: 14, label: '地代下级无店商CAND',type:0},
    {id: 41, label: '省代PD',type:0},
    {id: 75, label: '省代下级无店商CAN',type:0},
    {id: 421, label: '地代RD',type:0},
    {id: 688, label: '地代下级零售商CAD',type:0},
    {id: 843, label: '省代下级零售商CA',type:0},
    {id: 428, label: '新通路客户', type:0},
    {id: 899, label: 'CVS',type:1},
    {id: 76, label: '一次性客户',type:1},
    {id: 77, label: '内部客户',type:1},
    { id: 78, label: '海外客户',type:1},
    { id: 999, label: '门店客户',type:1},
];

//上架客户类型
export const Customer_Types_Goods_Opts = [
    {id: 2, label: '大连锁商SKA'},
    {id: 5, label: '大零售商SCA'},
    {id: 41, label: '省代PD'},
    {id: 899, label: 'CVS'},

    {id: 10000, label: '流通渠道一级客户'}, //分销商 上架范围 新增
    {id: 10001, label: '流通渠道二级客户'},
    {id: 100002, label: '特殊渠道客户'},
    {id: 100003, label: '电子烟渠道二级客户'},
    {id: 100004, label: '一次性客户（纯快消）'},


];
//一次性客户 上架范围
export const Customer_once_Types_Goods_Opts = [

    {id: 100012, label: '一次性客户'},

];
//一次性客户 内部客户
export const Customer_inner_Types_Goods_Opts = [

    {id: 100022, label: '内部客户'},

];

//门店客户类型
export const Customer_Store_Types_Opts = [
    {id: 3, label: '品类店'},
    {id: 14, label: '明星店'},
    {id: 34, label: '集合店'},
    {id: 42, label: '专柜店'},
    {id: 3422, label: '专卖店'}
];
export class OnShelvesApi {
    constructor() {
    }
    protected static groupUrl = '/sku/sell/config';

    //获取列表数据
    public static async getSkuSellList(data) {
        let uri = this.groupUrl + '/loadSkuSellConfigData';
        return await ServerDistApi.send(uri, data);
    }

    //更改商品上架状态
    public static async updateSkuStatus(data) {
        let uri = this.groupUrl + '/changeStats';
        return await ServerDistApi.send(uri, data);
    }

    //通过id删除
    public static async deleteByDetailId(data) {
        let uri = this.groupUrl + '/deleteByDetailId';
        return await ServerDistApi.get(uri, data);
    }
    //查看明细信息
    public static async getSkuSellDetail(data) {
        let uri = this.groupUrl + '/loadConfigDetail';
        return await ServerDistApi.get(uri, data);
    }

    //确认上架
    public static async updateSkuSell(data) {
        let uri = this.groupUrl +'/updateSkuSellConfig';
        return await ServerDistApi.send(uri, data);
    }
    //查询分销商:type是list
    public static async getClientList(page, page_num, type, keyword , user_type) {
        let url = 'user/find/getClientOrStore';
        let formData =  {
            pageNum: page,
            pageSize: 20,
            user_type_in: type,
            search: keyword,
            user_type: user_type

        };
        let response = await ServerProdApidl.send(url, formData);


        //修改返回
        return response.result;
    }
    //查询门店信息
    public static async getStoreList(page, page_num, type, keyword) {

        let url = '/user/find/getClientOrStore';
        let formData =  {
            pageNum: page,
            pageSize: page_num,
            store_type_in: type,
            search: keyword
        };
        let response = await ServerProdApidl.send(url, formData);

        //修改返回
        return response.result;

    }
    //查询门店信息
    public static async getUserAndStoreList(page, page_num, user_type,store_type,once_type,inner_type, keyword) {

        let url = 'user/find/getClientOrStore';
        let formData =  {
            page: page,
            page_num: page_num,
            // type_in: type,
            user_type_in:user_type,
            store_type_in:store_type,
            once_type:once_type,
            inner_type:inner_type,
            search: keyword
        };
        let response = await ServerProdApi.send(url, formData);
        return response.result;

    }
}




